import { PropsWithChildren, useMemo } from 'react';
import { useColorScheme } from 'react-native';

import useBreakpoint from '../../hooks/useBreakpoint';

import { injectInsets, parseBreakpoints } from './ThemeProvider.utils';

import { ThemeContext } from '../index';
import {
  DEFAULT_THEME,
  RESPONSIVE_TOKENS,
  STATIC_TOKENS,
  COLOR_TOKENS,
} from '../index.content';
import { Theme } from '../index.types';
import useSafeAreaInsets from '../../hooks/useSafeAreaInsets';

function ThemeProvider({ children }: PropsWithChildren) {
  const insets = useSafeAreaInsets();
  const theme = useColorScheme() || DEFAULT_THEME;
  const breakpoint = useBreakpoint();
  const value = useMemo<Theme>(
    () => ({
      ...STATIC_TOKENS,
      ...injectInsets(parseBreakpoints(RESPONSIVE_TOKENS, breakpoint), insets),
      name: theme,
      color: COLOR_TOKENS[theme],
    }),
    [breakpoint, insets, theme],
  );

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
}

export default ThemeProvider;
